import { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const SidebarIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M7.5 2.91667V17.0833M17.5 7.83333C17.5 5.96667 17.5 5.03333 17.1367 4.32C16.8171 3.69282 16.3072 3.18291 15.68 2.86333C14.9667 2.5 14.0333 2.5 12.1667 2.5H7.83333C5.96667 2.5 5.03333 2.5 4.32 2.86333C3.69282 3.18291 3.18291 3.69282 2.86333 4.32C2.5 5.03333 2.5 5.96667 2.5 7.83333V12.1667C2.5 14.0333 2.5 14.9667 2.86333 15.68C3.18291 16.3072 3.69282 16.8171 4.32 17.1367C5.03333 17.5 5.96667 17.5 7.83333 17.5H12.1667C14.0333 17.5 14.9667 17.5 15.68 17.1367C16.3072 16.8171 16.8171 16.3072 17.1367 15.68C17.5 14.9667 17.5 14.0333 17.5 12.1667V7.83333Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}

export default SidebarIcon
